import React from 'react'
import { Input, Select } from 'loyal-react'
import PropTypes from 'prop-types'
import DatePicker from '../DatePicker'
import moment from 'moment'
import { connect } from 'react-redux'

import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'

const FormBillPayment = ({
  maskLengthAccountType,
  maskAccountType,
  accountType,
  handlerChangeAccountType,
  handleBarCodeChange,
  handlerGetData,
  billValue,
  pointsValue,
  isPriceEditable,
  barCode,
  dueDate,
  errorField,
  isLoadingChangeAccountType,
  serviceId,
  handleBarCodeBlur,
  pointsName,
  decimalPlaces,
  handleCoversionPointsValue,
  handleBillValue
}) => {
  return (
    <div className='row'>
      <div className='col-12 px-0'>
        <div className='row'>
          <Input
            id='codigo_barra'
            label='Código de barras'
            className='col-12 col-md-12'
            value={barCode}
            onChange={handleBarCodeChange}
            data-error='Código de barras inválido'
            mask={maskAccountType}
            valid={errorField}
            onBlur={handleBarCodeBlur}
          />
          <Select
            id='BillType'
            label='Selecione o tipo de conta'
            className='col-12 col-md-6 mt-2'
            displayValue='name'
            selectedValue='serviceId'
            options={accountType}
            onChange={handlerChangeAccountType}
            value={accountType.find(item => item.serviceId === serviceId)}
            data-error='Tipo de conta inválido'
            valid={errorField}
          />
          <div className='form-field col-12 col-md-6 mt-1'>
            <div className='row'>
              <DatePicker
                id='agendar_para'
                labelDescription='Data vencimento'
                required
                value={dueDate}
                minDate={moment(new Date())
                  .add(1, 'days')
                  .toDate()}
                onChange={handlerGetData}
              />
            </div>
          </div>
          <Input
            id='valor_conta'
            label='Valor da conta'
            className='col-12 col-md-6 mt-2'
            onChange={(e) => handleBillValue(e)}
            onBlur={() => handleCoversionPointsValue()}
            value={numberToStrCurrency(billValue, 2)}
            disabled={!isPriceEditable}
          />

          <Input
            id='valor_em_pontos'
            label={`Valor em ${pointsName}`}
            className='col-12 col-md-6 mt-2'
            value={
              pointsValue ? numberToStrCurrency(pointsValue, decimalPlaces) : ''
            }
            disabled={isPriceEditable ? 'true' : 'false'}
          />
        </div>
        <br />
        <div
          className={`btn-loading mr-auto ml-auto ${
            isLoadingChangeAccountType ? 'd-block' : 'd-none'
          }`}
          value='Carregando'
          aria-label='Carregando pagamento'
        >
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  )
}

FormBillPayment.propTypes = {
  maskLengthAccountType: PropTypes.number,
  maskAccountType: PropTypes.array,
  accountType: PropTypes.array,
  handlerChangeAccountType: PropTypes.func,
  handleBarCodeChange: PropTypes.func,
  handlerGetData: PropTypes.func,
  billValue: PropTypes.number,
  pointsValue: PropTypes.number,
  isPriceEditable: PropTypes.string,
  barCode: PropTypes.string,
  dueDate: PropTypes.string,
  errorField: PropTypes.bool,
  isLoadingChangeAccountType: PropTypes.bool,
  serviceId: PropTypes.string,
  handleBarCodeBlur: PropTypes.func,
  pointsName: PropTypes.string,
  decimalPlaces: PropTypes.number,
  handleCoversionPointsValue: PropTypes.func,
  handleBillValue: PropTypes.func
}

const mapStateToProps = ({ catalog: { currencyConfiguration } }) => ({
  pointsName: currencyConfiguration.pointsName,
  decimalPlaces: currencyConfiguration.decimalPlaces
})

export default connect(
  mapStateToProps,
  null
)(FormBillPayment)



// WEBPACK FOOTER //
// ./src/features/BillPayment/FormBillPayment.js